import { toast } from "react-toastify";
import { ApiResponseType } from "../api/apiHelper";
import commonNetwork from "../api/commonNetwork";
import { OptionModel } from "../types/OptionModel";

export const getParentAndChildUserHelper = async (
    setOptions?: (options: OptionModel[]) => void,
    setLoadingDataOptions?: (loading: boolean) => void
): Promise<OptionModel[] | void> => {
    try {
        setLoadingDataOptions?.(true);
        const result: ApiResponseType = await commonNetwork.get("/user/get-parent-child-users");

        if (result.isSuccess) {
            const options: OptionModel[] = result.data.map((item: any) => ({
                value: item.userId,
                label: item.userDesc ? `${item.userName} - ${item.userDesc}` : item.userName
            }));

            if (setOptions) {
                setOptions(options);
            }

            return options;
        } else {
            toast.error(result.errorMessage);
        }
    } catch (error) {
        toast.error("An error occurred while fetching parent users.");
    }
    finally { 
        setLoadingDataOptions?.(false);
    }
};